// Environment variable compatibility layer for Vite migration
// This file maps between REACT_APP_ and VITE_ prefixes

const getEnvVar = (viteKey: string, craKey: string): string | undefined => {
  // Try Vite env first (for Vite build)
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[viteKey];
  }
  // Fall back to process.env (for CRA build)
  if (typeof process !== 'undefined' && process.env) {
    return process.env[craKey];
  }
  return undefined;
};

// Detect if we're in production based on the hostname
const isProduction = typeof window !== 'undefined' && 
  (window.location.hostname === 'valulearn.app' || 
   window.location.hostname === 'www.valulearn.app' ||
   window.location.hostname.includes('valulearn'));

export const env = {
  API_URL: isProduction 
    ? 'https://api.valulearn.app/api'
    : (getEnvVar('VITE_API_URL', 'REACT_APP_API_URL') || 'http://localhost:3001/api'),
  ENV: isProduction ? 'production' : (getEnvVar('VITE_ENV', 'REACT_APP_ENV') || 'development'),
  GOOGLE_CLIENT_ID: getEnvVar('VITE_GOOGLE_CLIENT_ID', 'REACT_APP_GOOGLE_CLIENT_ID') || '998410210809-bd31l1h6juq583rejddld6rme3vjcc9s.apps.googleusercontent.com',
  NODE_ENV: typeof process !== 'undefined' ? process.env.NODE_ENV : 'development',
};

export default env;